<template>
  <div class="nav">
    <div class="navNav">
      <div class="bannerLogo">
        <img src="../assets/bannerLogo.png" alt />
      </div>
      <ul class="navNavLeft">
        <li
          v-for="(val,index) in list "
          :key="index"
          @click="changeRouter(index,val.url);"
          :class="[val.url=='/'+url?'mystyle':'',index==4&&pathUrl.indexOf('hyActivityDetail')>-1?'mystyle':'']"
          v-html="val.name"
        ></li>
        <!-- <li v-for="(val,index) in list " :key="index" @click="changeRouter(index,val.url);" >{{val.name}}</li> -->
        <!-- <li @click="toIndex(index1)" :class="index1==current?'mystyle':''">首页</li>
            <li @click="toHyActivity(index2)" :class="index2==current?'mystyle':''">行业动态</li>
            <li @click="toShopping(index3)" :class="index3==current?'mystyle':''">商城</li>
            <li @click="toDatabase(index4)" :class="index4==current?'mystyle':''">资料库</li>
            <li @click="tovaluetestonline(index5)" :class="index5==current?'mystyle':''">硬件测试查询</li>
        <li @click="toCommunication(index6)" :class="index6==current?'mystyle':''">交流圈</li>-->
      </ul>
      <ul class="navNavPeople" @click="toPerCenter()" v-show="isEndLogin">
        <li class="PeopleheadLi">
          <img :src="user.headUrl!=null && user.headUrl!=undefined?user.headUrl:imgUrl" alt />
        </li>
        <li
          id="PeopleName"
          v-text="user.nickName!=null && user.nickName!=undefined?user.nickName:user.userName"
        ></li>
        <li class="people" id="peopleId">
          <img src="../assets/people.png" alt />
        </li>
      </ul>
      <ul class="navNavRight" v-show="!isEndLogin">
        <li class="newLi" v-on:click="select(login)" id="newLitwo">登录</li>
        <li class="linea" id="linea">|</li>
        <li class="newLi" v-on:click="select(Register)" id="newLione">注册</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  name: "navtab",
  data() {
    return {
      iscommunicationPage: true,
      user: "",
      login: 1,
      Register: 2,
      isEndLogin: false,
      aorb: true,
      imgUrl: require("@/assets/head.jpg"),
      current: 0,
      url: "",
      list: [
        {
          name: "首页",
          url: "/",
          method: "toIndex"
        },
        {
          name: " <div>电磁阀在线查询</div>",
          url: "/valuetestonline",
          method: "tovaluetestonline"
        },
        {
          name: "在线商城",
          url: "/shopping",
          method: "toShopping"
        },
        {
          name: "资料库",
          url: "/database",
          method: "toDatabase"
        },
        {
          name: "行业动态",
          url: "/hyActivity",
          method: "toHyActivity"
        },
        {
          name: "交流圈",
          url: "/communication",
          method: "toCommunication"
        }
      ],
      pathUrl: ""
    };
  },

  methods: {
    changeRouter(index, url) {
      if (index == 0) {
        var flag = 1;
        sessionStorage.setItem("flag", flag);
      }
      this.current = index;
      //console.log(index, this.current);
      //console.log(index == this.current);
      //console.log(url);

      if (url == "/") {
        this.reload();
      }
      // if (this.user) {
      this.$router.push(url);
      // } else {
      //   this.isEndLogin = false;
      //   this.$notify({
      //     title: "温馨提示",
      //     message: "为了给您更加优质的服务，请先登录",
      //     type: "warning"
      //   });
      //   this.$router.push("/");
      // }
      this.current = index;
    },
    // toIndex(index) {
    //   this.$router.push("/");
    //   this.current = index;
    //   //console.log(index, this.current);
    // },
    // toCommunication(index) {
    //   this.current = index;
    //   //console.log(index, this.current);
    //   //console.log(index == this.current);
    //   if (this.user) {
    //     this.$router.push("/communication");
    //   } else {
    //     this.isEndLogin = true;
    //     alert("为了给您提供更加优质的服务，请先登录");
    //     this.$router.push("/");
    //   }
    // },
    // tovaluetestonline(index) {
    //   this.current = index;
    //   //console.log(index, this.current);
    //   if (this.user) {
    //     this.$router.push("/valuetestonline");
    //   } else {
    //     this.isEndLogin = true;
    //     alert("为了给您提供更加优质的服务，请先登录");
    //     this.$router.push("/");
    //   }
    // },
    // toHyActivity(index) {
    //   this.current = index;
    //   //console.log(index, this.current);
    //   if (this.user) {
    //     this.$router.push("/hyActivity");
    //   } else {
    //     this.isEndLogin = true;
    //     alert("为了给您提供更加优质的服务，请先登录");
    //     this.$router.push("/");
    //   }
    // },
    // toDatabase(index) {
    //   this.current = index;
    //   //console.log(index, this.current);
    //   if (this.user) {
    //     this.$router.push("/database");
    //   } else {
    //     this.isEndLogin = true;
    //     alert("为了给您提供更加优质的服务，请先登录");
    //     this.$router.push("/");
    //   }
    // },
    toPerCenter() {
      if (this.user) {
        this.$router.push("/perCenter");
      } else {
        this.isEndLogin = true;
        this.$notify({
          title: "温馨提示",
          message: "为了给您更加优质的服务，请先登录",
          type: "warning"
        });
        this.$router.push("/");
      }
    },
    // toShopping(index) {
    //   this.current = index;
    //   //console.log(index, this.current);
    //   if (this.user) {
    //     this.$router.push("/shopping");
    //   } else {
    //     this.isEndLogin = true;
    //     alert("为了给您提供更加优质的服务，请先登录");
    //     this.$router.push("/");
    //   }
    // },
    // /api/personal/userInfo/{userName}通过用户名获取个人信息
    getPerInfo() {
      this.$axios
        .get(this.$http + "api/personal/userInfo/" + this.user.userId)
        .then(res => {
          //console.log(res);
          if (res.data.code == 0) {
            // alert("成功");
            //console.log("通过用户名获取个人信息成功");
          } else {
            // alert("失败");
            // //console.log('通过用户名获取个人信息失败');
            this.$notify({
              title: "警告",
              message: "通过用户名获取个人信息失败,请您先重新登录或尝试刷新",
              type: "warning"
            });
          }
        })
        .catch(err => {});
    },
    select(selectFlag) {
      var flag = null;
      sessionStorage.setItem("flag", flag);
      //console.log(selectFlag);
      this.$emit("select", selectFlag);
      if (this.pathUrl.indexOf("communication") == -1) {
        this.$router.push("/");
      }
      // window.location.reload();
    }
  },
  created() {
    var url = window.location.href;

    url = url.split("?")[0]; // 我们只要?号前的
    var urlSlashCount = url.split("/").length; // 统计有3斜杠
    // 当前地址 小写表示
    url = url.split("/")[urlSlashCount - 1];
    this.url = url;
    this.pathUrl = window.location.href;
    //console.log(this.pathUrl);
  },
  mounted() {
    if (sessionStorage.getItem("user")) {
      this.user = JSON.parse(sessionStorage.getItem("user"));
    }
    // this.user = JSON.parse(sessionStorage.getItem("user"));
    //console.log(this.user);
    if (this.user) {
      this.isEndLogin = true;
    }
    //console.log(this.pathUrl);
    // indexOf() 方法可返回某个指定的字符串值在字符串中首次出现的位置。如果要检索的字符串值没有出现，则该方法返回 -1。
    // if(this.pathUrl.indexOf("communication") != -1){
    //   this.iscommunicationPage=false;
    // }
    // if(this.pathUrl.indexOf("valuetestonline") != -1){
    //   this.iscommunicationPage=false;
    // }
  }
};
</script>

<style>
.nav #linea {
  right: 88px;
  color: #717070;
  font-weight: 400;
}
.nav #newLitwo {
  right: 131px;
}
.nav .disabled {
  pointer-events: none;
}
.nav {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
}
/* .nav li:hover {
  border-bottom: 3px solid #158DD3;
  color: #158DD3;
} */
.nav .bannerLogo {
  width: 10%;
  height: 80px;
  position: relative;
  /* background-color: yellow; */
  /* position: relative;
  left: 13%; */
}
.nav .bannerLogo img {
  display: block;
  max-width: 100%;
  height: 24px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.nav .navNav {
  width: 100%;
  height: 80px;
  /* line-height: 80px; */
  font-size: 14px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff;
}
.nav .navNav .navNavLeft,
.nav .navNav .navNavRight {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 100%;
  /* margin: 0 10%; */
  margin: 0 0;
  /* margin-left: 13%; */
  background-color: #fff;
}
.nav .navNav .navNavRight {
  justify-content: center;
}
.nav .navNav .navNavLeft {
  width: 40%;
  background-color: #fff;
}
.nav .navNav .navNavRight {
  width: 30%;
  position: relative;
}
.nav .navNav .navNavRight .headLi {
  height: 46px;
  width: 46px;
  /* background-color: pink; */
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  left: 0%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  border: 1px solid #ccc;
}
.nav .navNav .navNavRight .headLi img {
  display: block;
  width: 100%;
  height: 100%;
}
.nav .navNav .navNavRight li {
  height: 50%;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* width: 100px;
  width: 14%; */
  /* background-color: blue; */
  /* display: table-cell;
  vertical-align:middle; */
  /* background-color: pink; */
  vertical-align: middle;
  font-weight: normal;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.nav .navNav .navNavLeft li {
  box-sizing: content-box;
  height: 50%;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* width: 100px;
  width: 14%; */
  /* background-color: blue; */
  /* display: table-cell;
  vertical-align:middle; */
  /* background-color: pink; */
  vertical-align: middle;
  font-weight: normal;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  /* border-bottom: 1px solid #fff; */
   /* border-bottom: 1px solid #158dd3; */
}
.nav .mystyle {
  /* text-decoration: underline; */
  border-bottom: 2px solid #158dd3!important;
  color: #158dd3;
}
.nav .navNav .navNavRight li {
  width: auto;
  position: absolute;
  right: 58px;
}

.nav .navNav .navNavLeft li:hover,
.nav .navNav .navNavRight li:hover {
  /* color: #fff; */
  /* border-bottom: 2px solid #fff; */
  cursor: pointer;
}
/* .nav .navNav .navNavLeft li:hover {
  text-decoration: underline;
} */
.nav .navNav .navNavRight .linea {
  /* width: 50px;
  text-align: center;
  background-color: pink; */
  margin-left: 20px;
  margin-right: 20px;
}
.nav .el-icon-setting {
  height: 100%;
  line-height: 66px;
  margin-left: 5px;
  right: 160px !important;
}
.nav #perName {
  width: 6.25rem;
  text-align: left;
}
/* <ul class="navNavPeople" @click="toPerCenter()" v-show="isEndLogin">
        <li class="PeopleheadLi">
          <img :src="user.headUrl!=null && user.headUrl!=undefined?user.headUrl:imgUrl" alt />
        </li>
        <li id="PeopleName" v-text="user.nickName!=null && user.nickName!=undefined?user.nickName:'匿名'"></li>
        <li class="people">
          <img src="../assets/people.png" alt="">
        </li>
      </ul> */
.nav #PeopleName {
  /* width: 6.25rem; */
  text-align: left;
  margin-left: 20px;
  word-wrap: none;
  word-break: keep-all;
  line-height: 80px;
}
.nav .navNavPeople {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 100%;
  /* margin: 0 10%; */
  margin: 0 0;
  margin-left: 13%;
  /* position: relative; */
  /* top: 50%; */
  cursor: pointer;
}
.nav .PeopleheadLi {
  height: 46px;
  width: 46px;
  /* background-color: pink; */
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  top: 50%;
  /* left: 0%;
  /*  */
  transform: translateY(-50%);
  z-index: 999;
}
.nav .PeopleheadLi img {
  display: block;
  width: 100%;
  height: 100%;
}
.nav .people {
  height: 20px;
  width: 20px;
  /* background-color: pink; */
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  top: 50%;
  /* left: 0%;
  /*  */
  transform: translateY(-50%);
  z-index: 999;
  margin-left: 10px;
}
.nav .people img {
  display: block;
  width: 100%;
  height: 100%;
}
.nav #peopleId {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/navtab.vue